import mixTraits from "../mixTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
class ResultPendingCatalogItemTraits extends mixTraits(CatalogMemberTraits) {}
export default ResultPendingCatalogItemTraits;